// extracted by mini-css-extract-plugin
export default {"wrapper":"PoemSection_wrapper__vkLen","wrap":"PoemSection_wrap__8FIqO","subText":"PoemSection_subText__Zk2kp","supText":"PoemSection_supText__cAoZj"};